import User from "../interfaces/User";
import ProposalState from "./GigState";

const foodPreferences = [
  "Atkins",
  "American",
  "Ayurveda",
  "Baking & Pastry",
  "Bone Broth",
  "Cajun",
  "Carribean",
  "Chinese",
  "Comfort Food",
  "Fine Dining",
  "French",
  "Fusion",
  "Greek",
  "Hawaiian",
  "Holistic Nutrition",
  "Indian",
  "Italian",
  "Japanese",
  "Keto",
  "Macrobiotic",
  "Mexican",
  "Medical Medium",
  "Mediterranean",
  "Middle Eastern",
  "Morrocan",
  "Nutrition Consulting",
  "Lebonese",
  "Picnics",
  "Plant-Paradox",
  "Pre/post Natal",
  "Raw-vegan",
  "Southern",
  "Thai",
  "TCM",
  "Turkish",
  "Vegetarian",
  "Vegan",
  "Vietnamese",
  "Whole30",
  "Zero Waste",
] as const;

const customFoodPreferences = [
  "Vegan Keto",
  "Vegan Paleo",
  "Vegan Gluten Free",
] as const;

const pronouns = ["He/him", "She/her", "Other"] as const;
const chefServices = [
  "On going meal prep",
  "Private chef",
  "Retreat catering",
  "Wedding catering",
  "Cooking class",
  "Vacation booking",
  "Pre/post natal support",
] as const;

const chefOfferingFieldNames: (keyof User)[] = [
  "chefServices",
  "cuisineTypes",
  "hourlyRate",
];

const publicProfileFieldNames: (keyof User)[] = [
  "tagline",
  "bio",
  "culinaryTraining",
  "otherTraining",
  "chefServices",
  "cuisineTypes",
  "address",
];

const clientPublicProfileGigsState = [
  ProposalState.NEW_GIG,
  ProposalState.OPEN_BID,
  ProposalState.FINISHED_AND_PAID,
];

const chefPublicProfileGigsState = [
  ProposalState.ACCEPTED_BOOKED,
  ProposalState.FINISHED_AND_PAID,
];

export {
  chefOfferingFieldNames,
  chefPublicProfileGigsState,
  chefServices,
  clientPublicProfileGigsState,
  foodPreferences,
  customFoodPreferences,
  pronouns,
  publicProfileFieldNames,
};
